/**
 * Returns a formatted description of a list of file types.
 * @param fileTypeKeys - an array of {@link FileTypeKey}s. Each one is expected to be a lowercase file
 * extension without a dot, like 'csv'. An example input would be: `['csv', 'xls', 'xlsx']`
 * @returns a formatted message like `'.csv, .xls or .xlsx files'`, or null if the fileTypeKeys array
 * is empty
 */
export const getFileTypesMessage = (
    fileTypeKeys: FileTypeKey[],
): Maybe<string> => {
    if (fileTypeKeys.length === 0) {
        return null;
    }

    return fileTypeKeys
        .flatMap((fileTypeKey, index) => {
            const fileTypeKeyWithDot = `.${fileTypeKey}`;

            if (index === fileTypeKeys.length - 2) {
                return [fileTypeKeyWithDot, 'or'];
            }

            if (index === fileTypeKeys.length - 1) {
                return [fileTypeKeyWithDot, 'files'];
            }

            return [`${fileTypeKeyWithDot},`];
        })
        .join(' ');
};
